import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import store from 'store'

import RoleChangeModal from './RoleChangeModal'

import { switchRole } from 'routing/fetchingfunction/user/user.action'
import { selectRole, selectUserData } from 'routing/fetchingfunction/user/user.reducer'

import { STUDENT_ROLE, TUTOR_ROLE } from 'constants/global'

import greenCheckmarkFlat from 'assets/icon/green-checkmark-flat.svg'

const activeClassName = '!text-[#F67443] bg-white'
const switchRoleClassName =
  'w-auto h-full inline-flex items-center !border border-transparent !px-2 !py-1 text-[#fff] rounded-full hover:cursor-pointer'

const SelectRole = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const userData = useSelector(selectUserData)
  const role = useSelector(selectRole)

  const [newRole, setNewRole] = useState(null)
  const [isRoleChangeModalOpen, setIsRoleChangeModalOpen] = useState(false)

  const handleToggleRole = () => {
    if (role === STUDENT_ROLE) {
      handleTutorClick()
    } else {
      handleStudentClick()
    }
  }

  const handleStudentClick = () => {
    if (!userData.user_student_profile) {
      setNewRole(STUDENT_ROLE)
      setIsRoleChangeModalOpen(true)
      return
    }

    store.set('user_role', STUDENT_ROLE)
    dispatch(switchRole(STUDENT_ROLE))
      .unwrap()
      .then(() => navigate(`/${STUDENT_ROLE}`))
      .catch((error) => console.error('Error switching role:', error))
  }

  const handleTutorClick = () => {
    if (!userData.user_tutor_profile) {
      setNewRole(TUTOR_ROLE)
      setIsRoleChangeModalOpen(true)
      return
    }

    store.set('user_role', TUTOR_ROLE)
    dispatch(switchRole(TUTOR_ROLE))
      .unwrap()
      .then(() => navigate(`/${TUTOR_ROLE}`))
      .catch((error) => console.error('Error switching role:', error))
  }

  const handleCloseRoleChangeModal = () => {
    setIsRoleChangeModalOpen(false)

    setTimeout(() => {
      setNewRole(null)
    }, 300)
  }

  const handleContinueRoleChangeModal = () => {
    navigate(`/${role}/switch`)

    handleCloseRoleChangeModal()
  }

  return (
    <>
      <div className="inline-flex items-center justify-center !mr-5 bg-[#FF9154] rounded-full px-1 py-1 h-10">
        <div
          className={`${switchRoleClassName} ${role === STUDENT_ROLE ? activeClassName : ''}`}
          onClick={handleStudentClick}
        >
          <span className="mr-2">Student</span>

          {role === STUDENT_ROLE && (
            <img className="w-[13px] h-[13px]" src={greenCheckmarkFlat} alt="Checkmark" />
          )}
        </div>

        <div
          className={`${switchRoleClassName} ${role === TUTOR_ROLE ? activeClassName : ''}`}
          onClick={handleTutorClick}
        >
          <span className="mr-2">Tutor</span>

          {role === TUTOR_ROLE && (
            <img className="w-[13px] h-[13px]" src={greenCheckmarkFlat} alt="Checkmark" />
          )}
        </div>
      </div>

      <RoleChangeModal
        role={newRole}
        open={isRoleChangeModalOpen}
        onClose={handleCloseRoleChangeModal}
        onContinue={handleContinueRoleChangeModal}
      />
    </>
  )
}

export default SelectRole
